"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: user/family-invite-info.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fuser%2Ffamily-invite-info.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.familyInviteStatusToJSON = exports.familyInviteStatusFromJSON = exports.ReceivedInviteMember = exports.ReceivedInvite = exports.FamilyInviteInfo = exports.FamilyInviteStatus = void 0;
const alias_1 = require("../common/alias");
const family_group_1 = require("../common/family-group");
const kyc_1 = require("../common/kyc");
const legal_name_1 = require("../common/legal-name");
const protobufPackage = 'com.step.user.proto';
var FamilyInviteStatus;
(function (FamilyInviteStatus) {
    FamilyInviteStatus["INVALID"] = "INVALID";
    FamilyInviteStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    FamilyInviteStatus["PENDING"] = "PENDING";
    FamilyInviteStatus["ACCEPTED"] = "ACCEPTED";
    FamilyInviteStatus["REJECTED"] = "REJECTED";
    FamilyInviteStatus["EXPIRED"] = "EXPIRED";
    FamilyInviteStatus["DELETED"] = "DELETED";
    FamilyInviteStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(FamilyInviteStatus || (exports.FamilyInviteStatus = FamilyInviteStatus = {}));
function createBaseFamilyInviteInfo() {
    return {
        familyId: '',
        inviterUserId: '',
        inviteeAlias: alias_1.Alias.fromPartial({}),
        group: family_group_1.FamilyGroup.FAMILY_INVALID,
        status: FamilyInviteStatus.INVALID,
        managedUserId: '',
        createdAtMs: '0',
        updatedAtMs: '0',
    };
}
exports.FamilyInviteInfo = {
    fromJSON(object) {
        const message = {
            familyId: isSet(object.familyId) ? globalThis.String(object.familyId) : '',
            inviterUserId: isSet(object.inviterUserId) ? globalThis.String(object.inviterUserId) : '',
            inviteeAlias: isSet(object.inviteeAlias)
                ? alias_1.Alias.fromJSON(object.inviteeAlias)
                : alias_1.Alias.fromPartial({}),
            group: isSet(object.group) ? (0, family_group_1.familyGroupFromJSON)(object.group) : family_group_1.FamilyGroup.FAMILY_INVALID,
            status: isSet(object.status)
                ? familyInviteStatusFromJSON(object.status)
                : FamilyInviteStatus.INVALID,
        };
        if (isSet(object.managedUserId)) {
            message.managedUserId = globalThis.String(object.managedUserId);
        }
        if (isSet(object.createdAtMs)) {
            message.createdAtMs = globalThis.String(object.createdAtMs);
        }
        if (isSet(object.updatedAtMs)) {
            message.updatedAtMs = globalThis.String(object.updatedAtMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.familyId !== '') {
            obj.familyId = message.familyId;
        }
        if (message.inviterUserId !== '') {
            obj.inviterUserId = message.inviterUserId;
        }
        if (message.inviteeAlias !== undefined) {
            obj.inviteeAlias = alias_1.Alias.toJSON(message.inviteeAlias);
        }
        if (message.group !== family_group_1.FamilyGroup.FAMILY_INVALID) {
            obj.group = (0, family_group_1.familyGroupToJSON)(message.group);
        }
        if (message.status !== FamilyInviteStatus.INVALID) {
            obj.status = familyInviteStatusToJSON(message.status);
        }
        if (message.managedUserId !== undefined && message.managedUserId !== '') {
            obj.managedUserId = message.managedUserId;
        }
        if (message.createdAtMs !== undefined && message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.updatedAtMs !== undefined && message.updatedAtMs !== '0') {
            obj.updatedAtMs = message.updatedAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.FamilyInviteInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFamilyInviteInfo();
        message.familyId = object.familyId ?? '';
        message.inviterUserId = object.inviterUserId ?? '';
        message.inviteeAlias = (object.inviteeAlias !== undefined && object.inviteeAlias !== null)
            ? alias_1.Alias.fromPartial(object.inviteeAlias)
            : alias_1.Alias.fromPartial({});
        message.group = object.group ?? family_group_1.FamilyGroup.FAMILY_INVALID;
        message.status = object.status ?? FamilyInviteStatus.INVALID;
        message.managedUserId = object.managedUserId ?? '';
        message.createdAtMs = object.createdAtMs ?? '0';
        message.updatedAtMs = object.updatedAtMs ?? '0';
        return message;
    },
};
function createBaseReceivedInvite() {
    return {
        id: '',
        group: family_group_1.FamilyGroup.FAMILY_INVALID,
        createdAtMs: '0',
        inviter: exports.ReceivedInviteMember.fromPartial({}),
        members: [],
        needsApproval: false,
        managedUserGraduation: false,
    };
}
exports.ReceivedInvite = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            group: isSet(object.group) ? (0, family_group_1.familyGroupFromJSON)(object.group) : family_group_1.FamilyGroup.FAMILY_INVALID,
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
            inviter: isSet(object.inviter)
                ? exports.ReceivedInviteMember.fromJSON(object.inviter)
                : exports.ReceivedInviteMember.fromPartial({}),
            members: globalThis.Array.isArray(object?.members)
                ? object.members.map((e) => exports.ReceivedInviteMember.fromJSON(e))
                : [],
            needsApproval: isSet(object.needsApproval) ? globalThis.Boolean(object.needsApproval) : false,
            managedUserGraduation: isSet(object.managedUserGraduation)
                ? globalThis.Boolean(object.managedUserGraduation)
                : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.group !== family_group_1.FamilyGroup.FAMILY_INVALID) {
            obj.group = (0, family_group_1.familyGroupToJSON)(message.group);
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.inviter !== undefined) {
            obj.inviter = exports.ReceivedInviteMember.toJSON(message.inviter);
        }
        if (message.members?.length) {
            obj.members = message.members.map((e) => exports.ReceivedInviteMember.toJSON(e));
        }
        if (message.needsApproval !== false) {
            obj.needsApproval = message.needsApproval;
        }
        if (message.managedUserGraduation !== false) {
            obj.managedUserGraduation = message.managedUserGraduation;
        }
        return obj;
    },
    create(base) {
        return exports.ReceivedInvite.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReceivedInvite();
        message.id = object.id ?? '';
        message.group = object.group ?? family_group_1.FamilyGroup.FAMILY_INVALID;
        message.createdAtMs = object.createdAtMs ?? '0';
        message.inviter = (object.inviter !== undefined && object.inviter !== null)
            ? exports.ReceivedInviteMember.fromPartial(object.inviter)
            : exports.ReceivedInviteMember.fromPartial({});
        message.members = object.members?.map((e) => exports.ReceivedInviteMember.fromPartial(e)) || [];
        message.needsApproval = object.needsApproval ?? false;
        message.managedUserGraduation = object.managedUserGraduation ?? false;
        return message;
    },
};
function createBaseReceivedInviteMember() {
    return {
        fullName: '',
        legalName: legal_name_1.LegalName.fromPartial({}),
        pictureUrl: '',
        kycStatus: kyc_1.KycStatus.INVALID,
        isOwner: false,
        aliases: [],
        isUnder13: false,
    };
}
exports.ReceivedInviteMember = {
    fromJSON(object) {
        const message = {
            fullName: isSet(object.fullName) ? globalThis.String(object.fullName) : '',
            legalName: isSet(object.legalName)
                ? legal_name_1.LegalName.fromJSON(object.legalName)
                : legal_name_1.LegalName.fromPartial({}),
            isOwner: isSet(object.isOwner) ? globalThis.Boolean(object.isOwner) : false,
            aliases: globalThis.Array.isArray(object?.aliases)
                ? object.aliases.map((e) => alias_1.Alias.fromJSON(e))
                : [],
            isUnder13: isSet(object.isUnder13) ? globalThis.Boolean(object.isUnder13) : false,
        };
        if (isSet(object.pictureUrl)) {
            message.pictureUrl = globalThis.String(object.pictureUrl);
        }
        if (isSet(object.kycStatus)) {
            message.kycStatus = (0, kyc_1.kycStatusFromJSON)(object.kycStatus);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.fullName !== '') {
            obj.fullName = message.fullName;
        }
        if (message.legalName !== undefined) {
            obj.legalName = legal_name_1.LegalName.toJSON(message.legalName);
        }
        if (message.pictureUrl !== undefined && message.pictureUrl !== '') {
            obj.pictureUrl = message.pictureUrl;
        }
        if (message.kycStatus !== undefined && message.kycStatus !== kyc_1.KycStatus.INVALID) {
            obj.kycStatus = (0, kyc_1.kycStatusToJSON)(message.kycStatus);
        }
        if (message.isOwner !== false) {
            obj.isOwner = message.isOwner;
        }
        if (message.aliases?.length) {
            obj.aliases = message.aliases.map((e) => alias_1.Alias.toJSON(e));
        }
        if (message.isUnder13 !== false) {
            obj.isUnder13 = message.isUnder13;
        }
        return obj;
    },
    create(base) {
        return exports.ReceivedInviteMember.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReceivedInviteMember();
        message.fullName = object.fullName ?? '';
        message.legalName = (object.legalName !== undefined && object.legalName !== null)
            ? legal_name_1.LegalName.fromPartial(object.legalName)
            : legal_name_1.LegalName.fromPartial({});
        message.pictureUrl = object.pictureUrl ?? '';
        message.kycStatus = object.kycStatus ?? kyc_1.KycStatus.INVALID;
        message.isOwner = object.isOwner ?? false;
        message.aliases = object.aliases?.map((e) => alias_1.Alias.fromPartial(e)) || [];
        message.isUnder13 = object.isUnder13 ?? false;
        return message;
    },
};
function familyInviteStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID':
            return FamilyInviteStatus.INVALID;
        case 6:
        case 'PENDING_APPROVAL':
            return FamilyInviteStatus.PENDING_APPROVAL;
        case 1:
        case 'PENDING':
            return FamilyInviteStatus.PENDING;
        case 2:
        case 'ACCEPTED':
            return FamilyInviteStatus.ACCEPTED;
        case 3:
        case 'REJECTED':
            return FamilyInviteStatus.REJECTED;
        case 4:
        case 'EXPIRED':
            return FamilyInviteStatus.EXPIRED;
        case 5:
        case 'DELETED':
            return FamilyInviteStatus.DELETED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return FamilyInviteStatus.UNRECOGNIZED;
    }
}
exports.familyInviteStatusFromJSON = familyInviteStatusFromJSON;
function familyInviteStatusToJSON(object) {
    switch (object) {
        case FamilyInviteStatus.INVALID:
            return 'INVALID';
        case FamilyInviteStatus.PENDING_APPROVAL:
            return 'PENDING_APPROVAL';
        case FamilyInviteStatus.PENDING:
            return 'PENDING';
        case FamilyInviteStatus.ACCEPTED:
            return 'ACCEPTED';
        case FamilyInviteStatus.REJECTED:
            return 'REJECTED';
        case FamilyInviteStatus.EXPIRED:
            return 'EXPIRED';
        case FamilyInviteStatus.DELETED:
            return 'DELETED';
        case FamilyInviteStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.familyInviteStatusToJSON = familyInviteStatusToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=family-invite-info.js.map